import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import App from "App";
import reportWebVitals from "reportWebVitals";
import "./assets/fonts/PlusJakartaSans-Regular/PlusJakartaSans-Regular.ttf";
import "./assets/fonts/PlusJakartaSans-Bold/PlusJakartaSans-Bold.ttf";
import "./assets/fonts/PlusJakartaSans-Medium/PlusJakartaSans-Medium.ttf";
import "./assets/fonts/PlusJakartaSans-SemiBold/PlusJakartaSans-SemiBold.ttf";

import "index.scss";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
